var OPERATOR_OPTIONS = [
  { value: 'equals', label: 'Equals (=)' },
  { value: 'not_equals', label: 'Not equals (!=)' },
  { value: 'contains', label: 'Contains' },
  { value: 'starts_with', label: 'Starts with' },
  { value: 'ends_with', label: 'Ends with' },
  { value: 'greater_than', label: 'Greater than (>)' },
  { value: 'greater_or_equal', label: 'Greater or equal (>=)' },
  { value: 'less_than', label: 'Less than (<)' },
  { value: 'less_or_equal', label: 'Less or equal (<=)' },
  { value: 'is_blank', label: 'Is blank' },
  { value: 'is_not_blank', label: 'Is not blank' },
  { value: 'is_number', label: 'Is number' },
  { value: 'is_string', label: 'Is string' },
  { value: 'is_true', label: 'Is true' },
  { value: 'is_false', label: 'Is false' },
  { value: 'regex', label: 'Regex' }
];

var OPERATOR_LABELS = {
  equals: '=',
  not_equals: '!=',
  contains: 'contains',
  starts_with: 'starts with',
  ends_with: 'ends with',
  greater_than: '>',
  greater_or_equal: '>=',
  less_than: '<',
  less_or_equal: '<=',
  is_blank: 'is blank',
  is_not_blank: 'is not blank',
  is_number: 'is number',
  is_string: 'is string',
  is_true: 'is true',
  is_false: 'is false',
  regex: 'regex'
};

var OPERATORS_WITHOUT_VALUE = {
  is_blank: true,
  is_not_blank: true,
  is_number: true,
  is_string: true,
  is_true: true,
  is_false: true
};

function operatorRequiresValue(operator) {
  return !OPERATORS_WITHOUT_VALUE[String(operator || '')];
}

function nextConditionId() {
  return 'cond-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
}

function nextGroupId() {
  return 'group-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
}

function normalizeConditionItem(item) {
  var operator = item && item.operator ? String(item.operator) : 'equals';
  var supported = OPERATOR_OPTIONS.some(function(option) {
    return option.value === operator;
  });

  return {
    type: 'condition',
    id: item && item.id ? String(item.id) : nextConditionId(),
    operator: supported ? operator : 'equals',
    value: item && item.value !== undefined && item.value !== null ? String(item.value) : ''
  };
}

function normalizeGroup(group, depth) {
  var safeDepth = typeof depth === 'number' ? depth : 0;
  var logic = group && String(group.logic || '').toLowerCase() === 'or' ? 'or' : 'and';
  var items = Array.isArray(group && group.items) ? group.items : [];
  var normalizedItems = [];

  for (var i = 0; i < items.length; i += 1) {
    var item = items[i];
    if (item && item.type === 'group' && safeDepth < 1) {
      normalizedItems.push(normalizeGroup(item, safeDepth + 1));
      continue;
    }
    normalizedItems.push(normalizeConditionItem(item));
  }

  if (!normalizedItems.length) {
    normalizedItems = [normalizeConditionItem(null)];
  }

  return {
    type: 'group',
    id: group && group.id ? String(group.id) : nextGroupId(),
    logic: logic,
    items: normalizedItems
  };
}

function collectConditionItems(node) {
  if (!node) return [];
  if (node.type === 'condition') return [node];
  if (!Array.isArray(node.items)) return [];

  var out = [];
  for (var i = 0; i < node.items.length; i += 1) {
    out = out.concat(collectConditionItems(node.items[i]));
  }
  return out;
}

function hasGroupChild(root) {
  if (!root || !Array.isArray(root.items)) return false;
  return root.items.some(function(item) {
    return item && item.type === 'group';
  });
}

function normalizeConditionRule(rule) {
  var explicitMode = rule && String(rule.mode || '').toLowerCase();
  var root = null;

  if (rule && rule.type === 'group') {
    root = normalizeGroup(rule, 0);
  } else if (rule && Array.isArray(rule.items)) {
    root = normalizeGroup({ type: 'group', logic: rule.logic, items: rule.items }, 0);
  } else if (rule && Array.isArray(rule.conditions)) {
    root = normalizeGroup({ type: 'group', logic: rule.logic, items: rule.conditions }, 0);
  } else if (rule && (rule.operator || rule.value !== undefined)) {
    root = normalizeGroup({ type: 'group', logic: rule.logic, items: [rule] }, 0);
  } else {
    root = normalizeGroup(null, 0);
  }

  var flatConditions = collectConditionItems(root);
  var inferredMode = flatConditions.length > 1 || hasGroupChild(root) ? 'advanced' : 'simple';
  var mode = explicitMode === 'advanced' || explicitMode === 'simple'
    ? explicitMode
    : inferredMode;

  return {
    mode: mode,
    logic: root.logic,
    conditions: flatConditions,
    root: root
  };
}

function hasAnyConditionValue(rule) {
  var normalized = normalizeConditionRule(rule);
  return normalized.conditions.some(function(item) {
    return conditionHasEffectiveValue(item);
  });
}

function conditionHasEffectiveValue(item) {
  if (!item) return false;
  if (!operatorRequiresValue(item.operator)) return true;
  return String(item.value || '').trim().length > 0;
}

function countConditionItems(rule) {
  return normalizeConditionRule(rule).conditions.length;
}

module.exports = {
  OPERATOR_OPTIONS: OPERATOR_OPTIONS,
  OPERATOR_LABELS: OPERATOR_LABELS,
  operatorRequiresValue: operatorRequiresValue,
  conditionHasEffectiveValue: conditionHasEffectiveValue,
  nextConditionId: nextConditionId,
  nextGroupId: nextGroupId,
  normalizeConditionItem: normalizeConditionItem,
  normalizeGroup: normalizeGroup,
  collectConditionItems: collectConditionItems,
  normalizeConditionRule: normalizeConditionRule,
  hasAnyConditionValue: hasAnyConditionValue,
  countConditionItems: countConditionItems
};
